const pages = {
    home:'home',
    breeds:'breeds',
    breed:'breed',
    subBreed: 'subBreed',
    notExistent:'notExistent'
}

export {pages}